import { render, staticRenderFns } from "./model_make.vue?vue&type=template&id=6f64769e&scoped=true"
import script from "./model_make.vue?vue&type=script&lang=js"
export * from "./model_make.vue?vue&type=script&lang=js"
import style0 from "./model_make.vue?vue&type=style&index=0&id=6f64769e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64769e",
  null
  
)

export default component.exports